'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$5() {
  this.bjo = null;
  this.bjm = null;
  this.bjn = false;
  this.bjk = null;
  this.bjl = false;
  this.bjp = false;
  this.bjq = false;
  this.bjo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$5 as $c_Lpresto_PrestoRouter$$anon$5 };
$p = $c_Lpresto_PrestoRouter$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$5;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$5() {
}
export { $h_Lpresto_PrestoRouter$$anon$5 as $h_Lpresto_PrestoRouter$$anon$5 };
$h_Lpresto_PrestoRouter$$anon$5.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bjo;
});
$p.t = (function() {
  if ((!this.bjn)) {
    this.bjm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bjn = true;
  }
  return this.bjm;
});
$p.ae = (function() {
  if ((!this.bjl)) {
    this.bjk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bjl = true;
  }
  return this.bjk;
});
$p.w = (function() {
  if ((!this.bjq)) {
    this.bjp = false;
    this.bjq = true;
  }
  return this.bjp;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$5, "presto.PrestoRouter$$anon$5", ({
  Og: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$5 as $d_Lpresto_PrestoRouter$$anon$5 };
//# sourceMappingURL=presto.-Presto-Router$$anon$5.js.map
